module.exports = __webpack_public_path__ + "img/green.352c2b93.gif";